import axios from "../customAxios.js";
import { useState } from "react";
import { TextField } from "@mui/material";
import * as EmailValidator from "email-validator";
import LoadingComponent from "../components/LoadingComponent";
import { getImagesUrls } from "../utils/s3Utils.js";
import AlertBox from "../components/AlertBox";
import { useImagePreloader } from "../hooks/useImagePreLoader.jsx";
import { useAuth } from "../hooks/useAuth.jsx";

const imageskeyRoutes = {
  s3Logo2: "assets/icons/nh.png",
  s3Dots: "assets/icons/dots.png",
  s3HomeVectors: "assets/icons/home-vectors.png",
  s3LogoWhite:
    "https://static.wixstatic.com/media/d57788_b9b38e53004a474b81cad819df75dc60~mv2.png",
};

const imageUrls = await getImagesUrls(imageskeyRoutes, "login");

axios.defaults.withCredentials = true;

function Login() {
  const { login, removeUserData, openAlert, setOpenAlert, messageAlert } =
    useAuth();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitPressed, setSubmitPressed] = useState(false);
  const { allImagesLoaded, timeoutReached } = useImagePreloader(
    imageUrls,
    5000
  );

  const handleLogInInputChange = (e) => {
    if (e.target.name === "email") {
      setEmail(e.target.value);
    } else if (e.target.name === "password") {
      setPassword(e.target.value);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitPressed(true);
    if (email !== "" && EmailValidator.validate(email) && password !== "") {
      login(email, password);
    }
  };

  return (
    <>
      {!allImagesLoaded && !timeoutReached ? (
        <LoadingComponent />
      ) : (
        <>
          <div className="split-container">
            <div className="half-black">
              <div className="topLeftImage">
                <img src={imageUrls.s3Dots} alt="dots" />
              </div>
              <div className="centerImage">
                <img
                  src="https://static.wixstatic.com/media/d57788_b9b38e53004a474b81cad819df75dc60~mv2.png"
                  alt="Logo NinjaHubs"
                />
              </div>
              <div className="bottomCenterImage">
                <img src={imageUrls.s3HomeVectors} alt="home" />
              </div>
            </div>
            <div className="half-white">
              <div className="login-form" align="center">
                <div
                  id="existing-customer"
                  className="panel-body"
                  data-hook="login"
                >
                  <div className="login-card">
                    <h4 className="title-login fw-medium">
                      Bienvenid@ a Ninja Hubs!
                    </h4>
                    <form noValidate autoComplete="off">
                      <TextField
                        fullWidth
                        error={
                          (submitPressed && email === "") ||
                          (submitPressed &&
                            email !== "" &&
                            !EmailValidator.validate(email))
                        }
                        variant="outlined"
                        label="Email"
                        name="email"
                        value={email}
                        onChange={(e) => handleLogInInputChange(e)}
                        helperText={
                          submitPressed && email === ""
                            ? "Campo obligatorio"
                            : submitPressed &&
                              email !== "" &&
                              !EmailValidator.validate(email)
                            ? "Formato incorrecto"
                            : ""
                        }
                      />
                      <TextField
                        fullWidth
                        error={submitPressed && password === ""}
                        variant="outlined"
                        label="Contraseña"
                        name="password"
                        type="password"
                        value={password}
                        onChange={(e) => handleLogInInputChange(e)}
                        helperText={
                          submitPressed && password === ""
                            ? "Campo obligatorio"
                            : ""
                        }
                      />
                      <div className="form-group" align="center">
                        <button
                          onClick={(e) => handleSubmit(e)}
                          className="mdl-button mdl-js-button mdl-js-ripple-effect btn-primary-custom btn-block"
                        >
                          Iniciar sesión
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <AlertBox
              severity="error"
              messageAlert={messageAlert}
              setOpenAlert={setOpenAlert}
              openAlert={openAlert}
              hideDuration={6000}
            />
          </div>
        </>
      )}
    </>
  );
}

export default Login;
